import { Text } from "@/elements"
import { HelpCircle } from "@/icons/outline"
import { ZendeskAPI } from "@/providers/ZenDesk"
import { NavItemWrapper } from "./NavItemWrapper"

export const HelpNavItem = () => {
  return (
    <div className="block sm:hidden" onClick={() => ZendeskAPI("messenger", "open")}>
      <NavItemWrapper>
        <HelpCircle className="stroke-fg-3" />
        <div className="absolute left-[44px] transition-opacity duration-200 ease-in-out md:opacity-0 lg:opacity-100">
          <Text variant={"h4"} className="text-fg-3">
            Help
          </Text>
        </div>
      </NavItemWrapper>
    </div>
  )
}
